import { render, staticRenderFns } from "./Restablecer.vue?vue&type=template&id=76c5b4a9&lang=pug&"
import script from "./Restablecer.vue?vue&type=script&lang=js&"
export * from "./Restablecer.vue?vue&type=script&lang=js&"
import style0 from "./Restablecer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VFlex,VLayout,VTextField})
